import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Typography, notification } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Text as CustomText, useText } from '@src/components';
import {
  postVehicleDeviceCancelRenew,
  getVehicleDetailList,
  incrementActiveTab,
  permanentlyCancelVehicleDevice,
} from '@src/store/slice/vehicleManagementStore/vehicleManagementDetailSlice';
const { Text } = Typography;

const VehicleManagementDetailCancelDeviceRenewModal = ({
  isVisible,
  handleOk,
  handleCancel,
  vehicleId,
  vehicleDetailId,
  providerType,
  onlyDelete = false,
}) => {
  const dispatch = useDispatch();
  const [api, contextHolder] = notification.useNotification();
  const { loading: loadingVehicleCancelRenewDevice } = useSelector(
    (state) => state.vehicleManagementDetail,
  );
  const permanentlyCancel = useText('permanentlyCancel');
  const deviceMalfunctionCancelAndRenew = useText('deviceMalfunctionCancelAndRenew');
  const transactionSuccessfullyCompleted2 = useText('transactionSuccessfullyCompleted2');

  const { selectedCustomer } = useSelector((state) => state?.customer);
  const { isAdmin } = useSelector((state) => state.auth);
  const { selectedUserId } = useSelector((state) => state.user);
  const onOk = async () => {
    try {
      const request = {
        vehicleDetailId: vehicleDetailId,
      };
      const response = await dispatch(
        onlyDelete
          ? permanentlyCancelVehicleDevice({ request })
          : postVehicleDeviceCancelRenew({ request }),
      ).unwrap();
      if (response.isSuccess) {
        api.success({
          message: onlyDelete ? permanentlyCancel : deviceMalfunctionCancelAndRenew,
          description: transactionSuccessfullyCompleted2,
          duration: 2,
        });
      }
      handleOk();
      setTimeout(async () => {
        await dispatch(
          getVehicleDetailList({
            customerId: isAdmin && selectedUserId ? selectedUserId : selectedCustomer.customerId,
            id: vehicleId,
            providerType: providerType,
          }),
        );
        await dispatch(incrementActiveTab('2'));
      }, 1500);
    } catch (error) {
      console.log('Validate Failed:', error);
    }
  };

  const onCancel = () => {
    handleCancel();
  };

  return (
    <>
      {contextHolder}
      {isVisible && (
        <div data-testid="vehicle-model-device-cancel-renew-id">
          <Modal
            title={
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <ExclamationCircleOutlined
                  style={{ color: '#FAAD14', fontSize: '24px', marginRight: '8px' }}
                />
                <Text strong style={{ fontSize: '16px' }}>
                  <CustomText t="attention" />
                </Text>
              </div>
            }
            visible={isVisible}
            onOk={onOk}
            onCancel={onCancel}
            footer={[
              <Button key="back" onClick={handleCancel}>
                <CustomText t="giveUp" />
              </Button>,
              <Button
                key="submit"
                type="primary"
                onClick={onOk}
                loading={
                  onlyDelete
                    ? loadingVehicleCancelRenewDevice.permanentlyCancelVehicleDeviceModal
                    : loadingVehicleCancelRenewDevice.vehicleCancelDeviceRenewModal
                }
                disabled={
                  onlyDelete
                    ? loadingVehicleCancelRenewDevice.permanentlyCancelVehicleDeviceModal
                    : loadingVehicleCancelRenewDevice.vehicleCancelDeviceRenewModal
                }
                data-testid="yes-button"
              >
                <CustomText t="yes" />
              </Button>,
            ]}
          >
            <Text strong style={{ fontSize: '18px' }}>
              {onlyDelete ? (
                <CustomText t="cancelSelectedDeviceConfirm" />
              ) : (
                <CustomText t="cancelSelectedDeviceAndRequestNewConfirm" />
              )}
            </Text>
          </Modal>
        </div>
      )}
    </>
  );
};

VehicleManagementDetailCancelDeviceRenewModal.propTypes = {
  isVisible: PropTypes.bool,
  handleOk: PropTypes.func,
  handleCancel: PropTypes.func,
  vehicleId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  vehicleDetailId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onlyDelete: PropTypes.bool,
  providerType: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default VehicleManagementDetailCancelDeviceRenewModal;
